import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApolloUserService } from '@core/graphql/apolloUser.service';
import { DatePipeService } from '@core/pipe/datepipe.service';

@Component({
    selector: 'app-profile-information',
    templateUrl: './profile-information.component.html',
    styleUrls: ['./profile-information.component.scss']
})
export class ProfileFormComponent implements OnInit {
    editForm!: FormGroup;
    userId: any;
    userDetail: any;
    isEditMode = false;
    submitted = false;
    loading: boolean = false;
    showAlert: boolean = false;
    alertProperties = { type: '', message: '' };
    modalState: boolean = false;
    modalTemplate: any = {};
    modalSize: any = {};
    profileImageBase64: string = '';

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private userService: ApolloUserService,
        private datePipeService: DatePipeService
    ) { }
    @ViewChild('fileInput') fileInput!: ElementRef;
    @ViewChild('saveTemplateHeader', { static: true }) saveTemplateHeader!: TemplateRef<object>;
    @ViewChild('saveTemplateBody', { static: true }) saveTemplateBody!: TemplateRef<object>;
    @ViewChild('saveTemplateFooter', { static: true }) saveTemplateFooter!: TemplateRef<object>;

    ngOnInit(): void {
        this.loadUserIdFromStorage();
        this.initData();
        this.initForm();
    }

    loadUserIdFromStorage(): void {
        const userProfile = localStorage.getItem("userProfile");
        if (userProfile) {
            const parsedProfile = JSON.parse(userProfile);
            this.userId = parsedProfile.id; // Extract userId from localStorage
        } else {
            console.error("User profile not found in localStorage");
            this.router.navigate(['/login']); // Redirect to login if no profile is found
        }
    }

    initData() {
        this.userDetail = null;
        if (this.userId) {
            this.getUserById(this.userId);
        }
    }

    initForm() {
        this.editForm = this.formBuilder.group({
            firstName: [null, Validators.required],
            lastName: [null, Validators.required],
            email: [null, Validators.required],
            phoneNumber: [null, Validators.required],
            newPass: ['']
        });
    }

    getUserById(id: any) {
        this.loading = true;
        this.userService.getUserById(id).subscribe({
            next: (result: any) => {
                this.loading = false;
                this.userDetail = result;
                if (result.profilePictureBase64) {
                    this.profileImageBase64 = `data:image/png;base64,${result.profilePictureBase64}`;
                } else {
                    this.profileImageBase64 = 'assets/images/user-profile.jpg';
                }
            },
            error: (error) => {
                this.loading = false;
                this.displayAlert("danger", "Failed to Fetch Data");
            }
        });
    }

    triggerFileInput() {
        this.fileInput.nativeElement.click();
    }

    onFileSelected(event: any) {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                const base64String = e.target.result.split(',')[1];

                this.profileImageBase64 = e.target.result;
                this.editForm.patchValue({
                    profilePictureBase64: base64String,
                    profilePictureType: file.type || "image/png"
                });
            };
            reader.readAsDataURL(file);
        }
    }

    onEdit() {
        this.isEditMode = true;
        this.editForm.patchValue({
            firstName: this.userDetail?.firstName,
            lastName: this.userDetail?.lastName,
            email: this.userDetail?.email,
            phoneNumber: this.userDetail?.phoneNumber,
            newPass: ''
        });
    }

    onCancel() {
        this.isEditMode = false;
    }

    onSave() {
        this.submitted = true;
        if (this.editForm.invalid) {
            return;
        }

        this.modalSize = { width: '500px', height: '250px' };
        this.modalState = true;
        this.modalTemplate = { header: this.saveTemplateHeader, body: this.saveTemplateBody, footer: this.saveTemplateFooter };
    }

    updateUser() {
        this.modalState = false;
        this.loading = true;
        this.submitted = true;
        const formValue = this.editForm.value;

        const userInput: any = {
            id: Number(this.userId),
            email: formValue.email,
            firstName: formValue.firstName,
            lastName: formValue.lastName,
            phoneNumber: formValue.phoneNumber,
            profilePictureBase64: this.profileImageBase64,
            profilePictureType: formValue.ProfilePictureType || "image/png"
        };

        if (formValue.newPass) {
            userInput.password = formValue.newPass;
        }

        this.userService.updateUser(userInput).subscribe({
            next: (response) => {
                if (response.success && response.success !== "") {
                    this.loading = false;
                    this.isEditMode = false;
                    this.initData();
                    this.initForm();
                    this.displayAlert("success", response.success);
                } else {
                    this.loading = false;
                    this.displayAlert("danger", response.error);
                }
            },
            error: (error) => {
                this.loading = false;
                this.displayAlert("danger", "Failed to update User");
            },
            complete: () => { },
        });
    }

    onCloseModal() {
        this.modalState = false;
    }

    displayAlert(type: string, message: string) {
        this.alertProperties.message = message;
        this.alertProperties.type = type;
        this.showAlert = true;

        setTimeout(() => {
            this.showAlert = false;
        }, 5000);
    }
}